<template>
    <div :class="computed_cols + ' ' + (vertical ? 'align-self-'+vertical : '')">
        <div :class="(title ? 'mb-3 ' : '') + 'form-group neutron'">
            <label :for="computed_id" v-if="title">
                <span class="text-wrap">
                    {{title}}
                </span>
                <i v-if="required == 'true'" class="fas fa-shield-alt"></i>
            </label>
            <input 
                v-on:input="$emit('input', $event.target.value)"
                :value="value"
                class="form-control"
                :name="name"
                :disabled="disabled == 'true' ? true : false"
                :id="computed_id"
                :required="required == 'true'"
                :autocomplete="autocomplete ? autocomplete : 'on'"
                :placeholder="placeholder"
                :type="type ? type : 'text'">
        </div>  
    </div>
</template>

<script>
export default {
    props: [
        'name',
        'title',
        'id',
        'required',
        'disabled',
        'vertical',
        'placeholder',
        'weight',
        'type',
        'value',
        'autocomplete'
    ],
    computed: {
        computed_id() {
            if(this.id == undefined) {
                return ('input-' + this._uid);
            } else {
                return this.id;
            }
        },
        computed_cols() {
            switch (this.weight) {
                case '0':
                    return 'col';            
                case '1':
                    return 'col-12';            
                case '2':
                    return 'col-xs-12 col-sm-6';            
                case '3':
                    return 'col-xs-12 col-sm-6 col-lg-4';            
                case '4':
                    return 'col-xs-12 col-sm-6 col-lg-4 col-xxl-3';            
                default:
                    return 'col-xs-12 col-sm-6 col-lg-4';
            }
        }
    },
}
</script>